<template>
    <div>
        <form @submit.prevent="onSubmit()">
            <div class="form-group">
                <label>Assegna un task a <strong>{{userInAssistance.email}}</strong></label>
                <textarea
                        v-model="formData.task"
                        class="form-control" rows="4" style="width:100% !important;"></textarea>
            </div>

            <div class="form-group">
                <label>deadline</label>
                <input type="date" class="form-control"
                       v-model="formData.date"/>
            </div>
            <button
                    type="submit"
                    class=" float-right btn btn-success  abtg__btn-third shadow-none abtg-button-big">
                Assegna il task
            </button>
        </form>
    </div>
</template>
<script>
    import {mapActions, mapState} from 'vuex';
    export default{
            props: {
                userInAssistance: {
                    type: Object,
                    required: false,
                },
            },
    computed: {
        ...mapState('n_supercoach', ['formData']),
    },
        methods:{
            ...mapActions('n_supercoach', ['onSubmit']),
        }
    }
</script>